export default __webpack_public_path__ + "static/media/crown.9412d035.svg";